import { defineStore } from "pinia";
import { ref } from "vue";

export const useImpersonateStore = defineStore("impersonate", () => {
  const isImpersonating = ref(false);
  const userImpersonateDetail = ref({
    email: "",
    firstName: "",
    id: "",
    lastName: "",
    userTypeId: "",
    isDistributor: false,
    googleSheetLink: null,
    earlyPayEligible:  false,
  });

  //added
  const resetImpersonation = () => {
    isImpersonating.value = false;
    userImpersonateDetail.value = {
      email: "",
      firstName: "",
      id: "",
      lastName: "",
      userTypeId: "",
      isDistributor: false,
      googleSheetLink: null,
      earlyPayEligible: false,
    };
  };

  return { isImpersonating, userImpersonateDetail, resetImpersonation };
}, {
  persist: false, 
});
